import { gql } from '@apollo/client'

/// Retourne la liste des transporteurs en fonction des filtres.
/// orderBy: NAME_ASC -> Les transporteurs sont donc retournés dans l'ordre alphabétique.
/// first et after fonctionne en couple (Pour le bouton suivant)
/// last et before fonctionne en couple (Pour le bouton précédent)
const TRANSPORTERS = gql`
  query transporters($first: Int, $after: Cursor, $before: Cursor, $last: Int) {
    transporters(orderBy: NAME_ASC, first: $first, after: $after, before: $before, last: $last) {
      edges {
        cursor
        node {
          color
          email
          firstNameContact
          id
          lastNameContact
          name
          nodeId
          phoneNumber
          transporterContacts {
            nodes {
              id
              firstName
              lastName
              email
              phoneNumber
              isPrimary
              isActive
            }
          }
          users {
            nodes {
              id
              firstname
              lastname
              licensePlate
              isActive
              companyRole
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`

const CREATE_TRANSPORTER = gql`
  mutation createTransporter(
    $color: String!
    $name: String!
  ) {
    createTransporter(
      input: {
        transporter: {
          name: $name
          color: $color
        }
      }
    ) {
      transporter {
        id
      }
    }
  }
`

const UPDATE_TRANSPORTER = gql`
  mutation updateTransporter(
    $color: String!
    $name: String!
    $id: UUID!
  ) {
    updateTransporter(
      input: {
        patch: {
          color: $color
          name: $name
        }
        id: $id
      }
    ) {
      clientMutationId
    }
  }
`

const CREATE_TRANSPORTER_CONTACT = gql`
  mutation createTransporterContact(
    $transporterId: UUID!
    $firstName: String!
    $lastName: String!
    $email: String!
    $phoneNumber: String!
    $isPrimary: Boolean!
  ) {
    createTransporterContact(
      input: {
        transporterContact: {
          transporterId: $transporterId
          firstName: $firstName
          lastName: $lastName
          email: $email
          phoneNumber: $phoneNumber
          isPrimary: $isPrimary
        }
      }
    ) {
      transporterContact {
        id
      }
    }
  }
`

const UPDATE_TRANSPORTER_CONTACT = gql`
  mutation updateTransporterContact(
    $id: UUID!
    $patch: TransporterContactPatch!
  ) {
    updateTransporterContact(
      input: {
        patch: $patch
        id: $id
      }
    ) {
      clientMutationId
    }
  }
`

const DELETE_TRANSPORTER_CONTACT = gql`
  mutation deleteTransporterContact($id: UUID!) {
    deleteTransporterContact(input: { id: $id }) {
      clientMutationId
    }
  }
`

export default {
  TRANSPORTERS,
  CREATE_TRANSPORTER,
  UPDATE_TRANSPORTER,
  CREATE_TRANSPORTER_CONTACT,
  UPDATE_TRANSPORTER_CONTACT,
  DELETE_TRANSPORTER_CONTACT,
}
